import { createSelector } from 'reselect';

import type RootState from 'app-components/utils/redux-store/rootState';

import { CREDIT_REPORT_REDUCER_KEY } from './types';
import { generateScoreDeltaTimeline } from './utils';

type State = Pick<RootState, typeof CREDIT_REPORT_REDUCER_KEY>;

export const getCreditReportStore = (state: State) => state[CREDIT_REPORT_REDUCER_KEY];
export const getLoadPending = (state: State) => getCreditReportStore(state).loadPending;
export const getIsLoading = (state: State) => getCreditReportStore(state).isLoading;
export const getError = (state: State) => getCreditReportStore(state).error;
export const getLastSyncDate = (state: State) => getCreditReportStore(state).lastSyncDate;
export const getCreditReport = (state: State) => getCreditReportStore(state).resourcesById.first();
export const getResourcesById = (state: State) => getCreditReportStore(state).resourcesById;

export const getCreditScoreHistory = createSelector(getCreditReport, (creditReport) =>
  generateScoreDeltaTimeline(creditReport?.creditScoreHistory),
);
